import React, { useState, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { mainContext } from '../../components/MainContext';


function SeoHeadTag() {
  const { t } = useTranslation();
  const langCode = useContext(mainContext).langCode;

  const [title, setTitle] = useState('ホーム | ピアノ教室経営 指導法オンラインサロン');
  const [description, setDescription] = useState('​ピアノ教室経営\n  指導法オンラインサロン\n  15分で両手で弾ける大人気のピアノ指導法\n  ・ピアノコンクールで入賞出来ずにいる、、\n  ・集客できない、、\n  \\丸ごとサポートさせて頂きます//');



  useEffect(() => {
    setTimeout(() => {
      setTitle(t('seo.title'));
      setDescription(t('seo.description'));
    }, 100)
  }, [langCode])


  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:site_name" content={title} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content="https://pianoonlinesalon.com/sns/" />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
}

export default SeoHeadTag;